import AOS from 'aos'
import CmmiInfoSection from 'components/AboutUsPage/CmmiInfoSection'
import ContactInformation from 'components/HomePage/ContactInformation'
import PageWrapper from 'components/PageWrapper'
import PAGE_CONSTANT_TEXTS from 'constants/pageMetaTags'
import Link from 'next/link'
import { useEffect, useState, useRef } from 'react'
import { Accordion, Button, Form } from 'react-bootstrap'
import Slider from 'react-slick'

import ContactSolutionsModal from 'components/ContactSolutionsModal'
import { TestimonialsVideoContent } from 'constants/TestimonialsVideo'
import { CDN_URL } from 'services/config'
import dynamic from 'next/dynamic'
import BreadcrumbList from 'components/StructuredData'
import { useRouter } from 'next/router'
import { FAQConstant } from 'constants/FAQConstant'

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

// const settings = {
//   dots: false,
//   infinite: true,
//   speed: 700,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   autoplay: true,
//   arrows: true,
// }

export async function getStaticProps() {
  return { props: { isErrorCls: true } }
}

function AppLikeTinder() {
  const [showContact, setShowContact] = useState(false)
  const handleShowContact = () => setShowContact(true)
  const handleCloseContact = () => setShowContact(false)
  const [autoPlay, setAutoPlay] = useState(false)
  const vidRef = useRef<any>([])
  const playVideo = (key) => {
    setAutoPlay(true)
    if (vidRef.current) {
      vidRef.current[key].play()
    }
  }
  useEffect(() => {
    AOS.init()
  }, [])

  const [playingStates, setPlayingStates] = useState(
    Array(TestimonialsVideoContent?.length).fill(false)
  )

  const pause = () => {
    setPlayingStates(Array(TestimonialsVideoContent?.length).fill(false))
  }

  const handleSetPlaying = (testimonialIndex) => {
    setPlayingStates((prevStates) =>
      prevStates.map((_, index) => (index === testimonialIndex ? true : false))
    )
  }

  const testimonialsSettings = {
    dots: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    beforeChange: pause,
    afterChange: pause,
  }

  const router: any = useRouter()
  const faqJsonData =
    FAQConstant[
      router.query.path ? router.query.path : router.pathname.split('/')[1]
    ]

  const schemaDataFAQ = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqJsonData.map(({ title, description }) => ({
      '@type': 'Question',
      name: title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: description,
      },
    })),
  }

  return (
    <PageWrapper {...PAGE_CONSTANT_TEXTS.appsLikeTinder}>
      <BreadcrumbList nameH1="Develop an App like tinder" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaDataFAQ) }}
      />
      <ContactSolutionsModal
        isOpen={showContact}
        onClose={handleCloseContact}
      />
      <main className="pt-120px main_sl">
        <div className="content-area content-page">
          <div className="vc_row wpb_row vc_row-fluid tinder-top-slider uber-top-slider top-slider">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="row vc_row wpb_row vc_inner vc_row-fluid inner-slider-detail">
                  <div className="lft_tp_bnr wpb_column vc_column_container col-md-8 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h1>
                            Do You Want To Develop A Dating App Like Tinder?
                          </h1>
                        </div>
                      </div>
                      <div className="wpb_raw_code wpb_content_element wpb_raw_html">
                        <div className="wpb_wrapper">
                          <div className="blg_form">
                            <Form.Group>
                              <Form.Label>
                                Yes, I Want To Develop An App Like
                              </Form.Label>
                              <select name="select_app" id="app_like_opt">
                                <option value="Tinder">Tinder</option>
                                <option value="Badoo">Badoo</option>
                                <option value="Bumble">Bumble</option>
                                <option value="Hinge">Hinge</option>
                                <option value="OKCupid">OKCupid</option>
                                <option value="Elite Singles">
                                  Elite Singles
                                </option>
                                <option value="Zoosk">Zoosk</option>
                                <option value="Happn">Happn</option>
                                <option value="Flutter">Flutter</option>
                                <option value="Her">Her</option>
                              </select>
                            </Form.Group>
                            <button
                              className="sbmt_frm_btm"
                              onClick={handleShowContact}
                            >
                              GET QUOTE
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="wpb_raw_code wpb_content_element wpb_raw_html">
                        <div className="wpb_wrapper">
                          <div className="our_achvnmet_prcto">
                            <h3>Our recognition in the industry</h3>
                            <ul>
                              <li>
                                <div className="cluth_img">
                                  <Link
                                    href="https://clutch.co/profile/webclues-infotech"
                                    target="_blank"
                                  >
                                    <img
                                      src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/Clutch.png`}
                                      className="lazy_webclues img-fluid"
                                      alt="Clutch"
                                    />
                                  </Link>
                                </div>
                                <div className="cluth_scn">
                                  <Link
                                    href="https://clutch.co/profile/webclues-infotech"
                                    target="_blank"
                                  >
                                    <p>Clutch</p>
                                    <h5>4.9 / 5</h5>
                                  </Link>
                                </div>
                              </li>
                              <li>
                                <div className="cluth_img">
                                  <Link
                                    href="https://www.goodfirms.co/company/webclues-infotech"
                                    target="_blank"
                                  >
                                    <img
                                      src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/Goodfirms.png`}
                                      className="lazy_webclues img-fluid"
                                      alt="Goodfirms"
                                    />
                                  </Link>
                                </div>
                                <div className="cluth_scn">
                                  <Link
                                    href="https://www.goodfirms.co/company/webclues-infotech"
                                    target="_blank"
                                  >
                                    <p>GoodFirms</p>
                                    <h5>4.91 / 5</h5>
                                  </Link>
                                </div>
                              </li>
                              <li>
                                <div className="cluth_img">
                                  <Link
                                    href="https://www.appfutura.com/developers/webcluesinfotech"
                                    target="_blank"
                                  >
                                    <img
                                      src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/Appfutura.png`}
                                      className="lazy_webclues img-fluid"
                                      alt="Appfutura"
                                    />
                                  </Link>
                                </div>
                                <div className="cluth_scn">
                                  <Link
                                    href="https://www.appfutura.com/developers/webcluesinfotech"
                                    target="_blank"
                                  >
                                    <p>AppFutura</p>
                                    <h5>5 / 5</h5>
                                  </Link>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rgt_tp_bnr wpb_column vc_column_container col-md-4 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center text-lg-end">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/tinder_mobile.png`}
                            className="single-image img-fluid"
                            alt="tinder_mobile"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid about_scn uber-cmnls z_sctn_1">
            <div className="container-sl">
              <div className="row">
                <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/about_mobile.png`}
                          className="single-image img-fluid"
                          alt="about_mobile"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right_about wpb_column vc_column_container col-md-6 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h3 className="tinder_title white_line_tilt">
                          <span style={{ fontWeight: 'bold' }}>
                            About Online Dating Industry
                          </span>
                        </h3>
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <p>
                          Online dating has become acceptable in today&apos;s
                          culture. Now connecting with people or finding someone
                          for dating is easy. Amid chaotic daily schedules,
                          people&apos;s lives are affected in many ways
                          including causing intense loneliness and isolation for
                          some; an online dating app brings a bright spot. It
                          has actually improved dating life from online dating
                          to texting, video chatting, etc. This has led us to be
                          in the midst of a digital revolution for human
                          courtship, where meeting people with similar thoughts,
                          values, faith, interests, background, and preferences
                          is plain sailing.
                        </p>
                        <p>
                          Online dating industry revenue is expected to show an
                          annual growth rate (CAGR 2020-2024) of 9.3%, resulting
                          in a projected market volume of US$2,505m by 2024.
                          Nowadays, people are specific about finding their
                          partners. They take into account the partner&apos;s
                          perception toward life, like-mindedness of critical
                          aspects, and likes &amp; dislikes. This has fuelled up
                          the dating service market to a large extent.
                        </p>
                        <p>
                          Developing a dating app can bring a fortune for you if
                          everything is done in a planned way and the execution
                          is done with perfection. Let WebClues Infotech take
                          you through every bit of information you must know
                          before starting your own mobile dating application.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid algorith_behind full-width-all-section">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="sm_column_text sm_content_element  tiktok_text">
                  <div className="sm_wrapper">
                    <h3 className="tinder_title">
                      <span style={{ fontWeight: 'bold' }}>Astonishing </span>
                      Statistics About Tinder&apos;s Success
                    </h3>
                    <p>
                      The aspiration to build a Tinder clone doesn&apos;t fade
                      over the years. Obviously, that&apos;s due to its stunning
                      popularity. Just take a look at the figures below:
                    </p>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid inner_algo_scn astonishin_he">
                  <div className="ylw_algo wpb_column vc_column_container col-md-3 sm-border-box mb-4">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/algo1.png`}
                            className="single-image img-fluid"
                            alt="algo1"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <p>
                            In the first quarter of 2020, there were 6.03
                            million paid Tinder subscribers worldwide
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="purpal_algo wpb_column vc_column_container col-md-3 sm-border-box mb-4">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/algo2.png`}
                            className="single-image img-fluid"
                            alt="algo2"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <p>
                            Tinder is spread over 190 countries also available
                            in 40 languages
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="blue_algo wpb_column vc_column_container col-md-3 sm-border-box mb-4">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/algo3.png`}
                            className="single-image img-fluid"
                            alt="algo3"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <p>
                            As of Q4 2019, Match Group reported an average 5.9
                            million Tinder subscribers
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="green_algo wpb_column vc_column_container col-md-3 sm-border-box mb-4">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/algo4.png`}
                            className="single-image img-fluid"
                            alt="algo4"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <p>Tinder sets up over 1 million dates per week</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid how_does_tinder">
            <div className="container-sl">
              <div className="row">
                <div className="pdng_left_cmn left_how_dstinder wpb_column vc_column_container col-md-8 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h3 className="tinder_title">
                          <span style={{ fontWeight: 'bold' }}>How Does</span>
                          <strong> Tinder</strong>&nbsp;Work?
                        </h3>
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element  tinder_content">
                      <div className="sm_wrapper">
                        <p>
                          Tinder is a free dating app available for Android and
                          iOS devices. It&nbsp;is a location-based social search
                          mobile app (using Facebook) that facilitates
                          communication between mutually interested users,
                          allowing matched users to chat. Users get to chat with
                          other users and potentially meet up with them. The
                          main attraction of Tinder is that it is very easy to
                          use in contrary to traditional dating sites. You can
                          easily create a Tinder account on your smartphone,
                          upload some photos, and youErrorre good to go. On the
                          Tinder platform, users swipe each other left and
                          right, right being a like and left a dislike. When
                          both users swipe right then they &apos;match&apos;,
                          meaning they can now chat with each other. When the
                          conversation on Tinder goes well, they&apos;ll usually
                          exchange numbers and/or go for a date.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right_hw_ds wpb_column vc_column_container col-md-4 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-end">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/does_tinder.png`}
                          className="single-image img-fluid"
                          alt="does_tinder"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid tinder_matcng_flw full-width-all-section">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="sm_column_text sm_content_element ">
                  <div className="sm_wrapper">
                    <h3 className="tinder_title white_line_tilt">
                      <span style={{ fontWeight: 'bold' }}>Tinder </span>
                      Matching Flow
                    </h3>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid inner_tindr_mtchng_flw width_5_clm">
                  <div className="wpb_column vc_column_container col-md-2 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix center mb-4">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/like.png`}
                            className="single-image img-fluid"
                            alt="like"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h5>Profile Setting</h5>
                          <p>
                            The functionality of the app should be such that it
                            must help the user to create an attractive profile
                            for them as matching is done based on the
                            user&apos;s profile.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-2 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix center mb-4">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/match.png`}
                            className="single-image img-fluid"
                            alt="match"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h5>Swipe</h5>
                          <p>
                            Swipe is Tinder&apos;s UVP (Unique Value
                            Proposition) feature. Add this feature to categorize
                            the candidates where users can swipe right to like
                            someone and left to reject someone.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-2 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix center mb-4">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/chat.png`}
                            className="single-image img-fluid"
                            alt="chat"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h5>Chat</h5>
                          <p>
                            Chatting is one of the best features. After finding
                            a match, users can immediately start a private
                            conversation with the other person using a build-in
                            unscripted messenger.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-2 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix center mb-4">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/share.png`}
                            className="single-image img-fluid"
                            alt="share"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h5>Match</h5>
                          <p>
                            When both users swipe right on each other&apos;s
                            profile, it will make them a match. Now, users can
                            chat with another person with mutual consent.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-2 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix center mb-4">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/moment.png`}
                            className="single-image img-fluid"
                            alt="moment"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h5>Passport to swipe</h5>
                          <p>
                            It allows users to get matches around the world by
                            simply searching for a city or dropping a pin on the
                            map.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid expensiv_smplty">
            <div className="container-sl">
              <div className="row">
                <div className="pdng_left_cmn left_expensive wpb_column vc_column_container col-md-6 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h3 className="tinder_title">
                          <span style={{ fontWeight: 'bold' }}>Tinder </span>App
                          Design Hooks You Up
                        </h3>
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element  tiktok_text">
                      <div className="sm_wrapper">
                        <p style={{ fontSize: '18px' }}>
                          Tinder app design works on behavioral psychology to
                          attract and engage users. &nbsp;The flawless user-
                          interaction, and yet the simple transition has proven
                          compelling enough to propel Tinder into the very heart
                          of the dating app world. Tinder experience revolves
                          around the acts of swiping and chatting, the user base
                          tends to interpret any added functionality as invasive
                          and unnecessary. In simpler words, Tinder is simply a
                          collection of elements, which works closely with
                          users- psychology to diminish the bite of rejection.
                          Whether it&apos;s the quick-swipe selection process,
                          the one-touch Facebook login, or the simple design,
                          Tinder is practicing minimalistic features to keep the
                          app simple yet attractive. Tinder has brought an
                          alternate route to access comfort and convenience when
                          it comes to unwinding the user&apos;s stress with
                          dating.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="right_expensive wpb_column vc_column_container col-md-6 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/simplcty_right.png`}
                          className="single-image img-fluid"
                          alt="simplcty_right"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid market_leader_tinder z_sctn_10 z_sctnpdng">
            <div className="container-sl">
              <div className="row">
                <div className="wpb_column vc_column_container col-md-12 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element  inln_ttl">
                      <div className="sm_wrapper">
                        <h3 className="tinder_title white_line_tilt text-center">
                          <span style={{ fontWeight: 'bold' }}>Market </span>
                          Leaders In Dating App Category
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/market1-1.png`}
                          className="single-image img-fluid"
                          alt="market1 (1)"
                        />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          <span style={{ color: '#1398c1' }}>
                            Happen $11.3 Billion
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/market2.png`}
                          className="single-image img-fluid"
                          alt="market2"
                        />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          <span style={{ color: '#f8c535' }}>
                            Bumble $2.2 Billion
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/market3.png`}
                          className="single-image img-fluid"
                          alt="market3"
                        />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          <span style={{ color: '#eb058c' }}>
                            Raya $201.4 Million
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/market4.png`}
                          className="single-image img-fluid"
                          alt="market4"
                        />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          <span style={{ color: '#21abd7' }}>
                            Hinge $7.2 Million
                          </span>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-12 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element  z_df_p">
                      <div className="sm_wrapper">
                        <p style={{ textAlign: 'center' }}>
                          After the launch of Tinder, hundreds of dating
                          services have appeared on app stores worldwide.
                          Investors are taking notice of this booming market
                          because online dating services are fast and
                          convenient. It is a fact that Tinder has a huge user
                          base; other dating apps like Happn, Bubble, etc. are
                          starting to meet a larger percentage of their user
                          expectations. These are some of the competitors of
                          Tinder giving tough competition in terms of user
                          experience.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <CmmiInfoSection className="mt-lg-0" />
          <div className="vc_row wpb_row vc_row-fluid time_line_tinder uber-cmnls z_sctn_15 z_sctnpdng full-width-all-section">
            <div className="container-sl">
              <div className="row">
                <div className="wpb_column vc_column_container col-md-12 sm-border-box mb-4">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element  inln_ttl z_df_p text-center">
                      <div className="sm_wrapper">
                        <h3
                          className="tinder_title text-center"
                          style={{ textAlign: 'center' }}
                        >
                          <span style={{ fontWeight: 'bold' }}>Timeline </span>
                          To Build An App Like Tinder
                        </h3>
                        <p style={{ fontSize: '18px' }}>
                          The scope of an app consists of various features,
                          functionalities, platform (s), and technology stack,
                          and these all factors influence the timeline of
                          development. However, the development time varies
                          greatly, and to help you get an overview of the level
                          of effort required in building an online dating app,
                          we&apos;ve got you the detailed information below.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-12 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="wpb_raw_code wpb_content_element wpb_raw_html">
                      <div className="wpb_wrapper">
                        <div className="cstm_tbl">
                          <table>
                            <thead>
                              <tr>
                                <th>Deliverables</th>
                                <th>Module</th>
                                <th>Sub Task</th>
                                <th>Estimated Hours</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  <span>General</span>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          Framework setup and configuration
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>API For Mobile</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          Setup and Configure Framework with
                                          database setup
                                        </td>
                                      </tr>
                                      <tr>
                                        <td />
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>80</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="empty-spc">
                                <td height="12px" colSpan={3} />
                              </tr>
                              <tr>
                                <td>
                                  <span>Backend</span>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>Admin User Management</td>
                                      </tr>
                                      <tr>
                                        <td>Application Users Management</td>
                                      </tr>
                                      <tr>
                                        <td>Subscription Management</td>
                                      </tr>
                                      <tr>
                                        <td>CMS Management</td>
                                      </tr>
                                      <tr>
                                        <td>Email Templates Management</td>
                                      </tr>
                                      <tr>
                                        <td>Reports</td>
                                      </tr>
                                      <tr>
                                        <td>Dashboard</td>
                                      </tr>
                                      <tr>
                                        <td>Site Settings Management</td>
                                      </tr>
                                      <tr>
                                        <td>Brands Management</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          Add/Edit/Delete/List Admin Users
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Edit/Delete/List Application Users
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>View/List subscription list</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Edit/Delete/List Content of the static
                                          pages
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Edit/Delete/List email templates
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Any 3 Reports</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Generic Dashboard as per the website
                                          data
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Site settings and configurations
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Add/Edit/Delete/List Brands</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>15</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>25</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>10</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>10</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="empty-spc">
                                <td height="12px" colSpan={3} />
                              </tr>
                              <tr>
                                <td>
                                  <span>Mobile Application (Android)</span>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>Splash Screen</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td className="he_b">Sign Up</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td className="he_b" />
                                      </tr>
                                      <tr className="empty-spc">
                                        <td
                                          className="he_b"
                                          style={{ height: '48px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td className="he_b" />
                                      </tr>
                                      <tr className="empty-spc">
                                        <td>Login</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '48px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>Forgot Password</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td>Dashboard</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '48px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>Notification</td>
                                      </tr>
                                      <tr>
                                        <td>Online Connection</td>
                                      </tr>
                                      <tr>
                                        <td>Profile Edit</td>
                                      </tr>
                                      <tr>
                                        <td>Others Profile</td>
                                      </tr>
                                      <tr>
                                        <td>Firebase And FCM Setup</td>
                                      </tr>
                                      <tr>
                                        <td>Logout</td>
                                      </tr>
                                      <tr>
                                        <td>Payment Gateway Integeration</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '28px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          style={{ height: '48px !important' }}
                                        >
                                          Sign Up with Name, Email, Password
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '56px' }}>
                                          Sign Up with Facebook and Google Plus
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Profile details</td>
                                      </tr>
                                      <tr>
                                        <td>Login with Email, Password</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Login with Facebook and Google Plus
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b_2"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>
                                          List of people arround, Like button,
                                          Side menu
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Promote option</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Message Notification Like Notification
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Online connection</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td className="he_b" />
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>2</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '57px' }}>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>2</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '48px' }}>
                                          <strong>18</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>24</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>1</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>24</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="empty-spc">
                                <td height="12px" colSpan={3} />
                              </tr>
                              <tr>
                                <td>
                                  <span>Mobile Application (iOS)</span>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>Splash Screen</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td className="he_b">Sign Up</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td className="he_b" />
                                      </tr>
                                      <tr className="empty-spc">
                                        <td
                                          className="he_b"
                                          style={{ height: '48px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td className="he_b" />
                                      </tr>
                                      <tr className="empty-spc">
                                        <td>Login</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '47px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>Forgot Password</td>
                                      </tr>
                                      <tr className="empty-spc">
                                        <td>Dashboard</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '47px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>Notification</td>
                                      </tr>
                                      <tr>
                                        <td>Online Connection</td>
                                      </tr>
                                      <tr>
                                        <td>Profile Edit</td>
                                      </tr>
                                      <tr>
                                        <td>Others Profile</td>
                                      </tr>
                                      <tr>
                                        <td>Firebase And FCM Setup</td>
                                      </tr>
                                      <tr>
                                        <td>Logout</td>
                                      </tr>
                                      <tr>
                                        <td>Payment Gateway Integeration</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '28px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          style={{ height: '50px !important' }}
                                        >
                                          Sign Up with Name, Email, Password
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '56px' }}>
                                          Sign Up with Facebook and Google Plus
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Profile details</td>
                                      </tr>
                                      <tr>
                                        <td>Login with Email, Password</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Login with Facebook and Google Plus
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b_2"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td>
                                          List of people arround, Like button,
                                          Side menu
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Promote option</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Message Notification Like Notification
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Online connection</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '45px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td className="he_b" />
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>2</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '57px' }}>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>2</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td style={{ height: '46px' }}>
                                          <strong>18</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>12</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>8</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>24</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>1</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>24</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="empty-spc">
                                <td height="12px" colSpan={3} />
                              </tr>
                              <tr>
                                <td>
                                  <span>Other</span>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>Application Design</td>
                                      </tr>
                                      <tr>
                                        <td>Design Integration</td>
                                      </tr>
                                      <tr>
                                        <td>PM and QA</td>
                                      </tr>
                                      <tr>
                                        <td>Deployment</td>
                                      </tr>
                                      <tr>
                                        <td>
                                          Server Setup &amp; Configuration
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td className="he_b">App Design</td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '43px' }}
                                        >
                                          PSD/SKETCH to APP Design Slicing
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '46px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td
                                          className="he_b"
                                          style={{ height: '48px' }}
                                        />
                                      </tr>
                                      <tr>
                                        <td className="he_b" />
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                                <td className="pdng-rmv">
                                  <table className="inner-tbl">
                                    <tbody>
                                      <tr>
                                        <td>
                                          <strong>30</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>4</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>16</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>24</strong>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          <strong>60</strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr className="empty-spc">
                                <td height="12px" colSpan={3} />
                              </tr>
                              <tr className="sb_ttl">
                                <td />
                                <td>Total Estimated Hours</td>
                                <td />
                                <td>636</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="vc_row wpb_row vc_row-fluid technolgy_stack z_sctn_13 z_sctnpdng pb-0"
            style={{ backgroundColor: '#f2f3f8' }}
          >
            <div className="container-sl">
              <div className="row">
                <div className="z_hght_at wpb_column vc_column_container col-md-12 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element text-center">
                      <div className="sm_wrapper">
                        <h3 className="tinder_title text-center">
                          <span style={{ fontWeight: 'bold' }}>
                            Technology{' '}
                          </span>
                          Stack For The App
                        </h3>
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element  inln_ttl z_df_p text-center">
                      <div className="sm_wrapper">
                        <p>
                          A dating portal requires a full-fledged technology
                          stack to function smoothly. In the field of back-end
                          &amp; front-end technologies, several frameworks and
                          languages must be considered to make it work and
                          synchronize in different mobile platforms. The
                          different set of technologies and frameworks is needed
                          to make the portal work efficiently as per the
                          requirement. Here, we have brought you a quick look at
                          technologies to be used in the development of the
                          dating mobile app portal like Tinder.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          For Android <br /> Development
                        </h4>
                      </div>
                    </div>
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/z_img_11.png`}
                          className="single-image img-fluid"
                          alt="z_img_11"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element  mrgn_13_120">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          For Backend <br /> Development
                        </h4>
                      </div>
                    </div>
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/Youtube_backend-1.png`}
                          className="single-image img-fluid"
                          alt="Youtube_backend (1)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container col-md-3 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h4 style={{ textAlign: 'center' }}>
                          For iOS <br /> Development
                        </h4>
                      </div>
                    </div>
                    <div className="sm-image sm_content_element clearfix text-center">
                      <div className="sm-image-wrap">
                        <img
                          src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/z_img_13.png`}
                          className="single-image img-fluid"
                          alt="z_img_13"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid how_much_mny_dtng full-width-all-section">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="sm_column_text sm_content_element ">
                  <div className="sm_wrapper">
                    <h3 className="tinder_title white_line_tilt text-center">
                      <span style={{ fontWeight: 'bold' }}>How Do </span>Online
                      Dating Apps Monetize?
                    </h3>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid">
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>01.</h4>
                            <h5>Sponsored Profiles</h5>
                          </div>
                          <p>
                            In this strategy, users can purchase memberships or
                            premium features on a monthly, quarterly, or yearly
                            basis. Also, users can collaborate with Dating App
                            to display their content just like profiles.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>02.</h4>
                            <h5>Freemium</h5>
                          </div>
                          <p>
                            Freemium is a popular strategy among dating apps,
                            which let users access the basic version of the app
                            for free and charge them for premium features. It is
                            a good strategy to adopt for initial user
                            acquisition.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid">
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>03.</h4>
                            <h5>Advertisements</h5>
                          </div>
                          <p>
                            This model enables the dating apps to get associated
                            with the third-party companies and advertise on the
                            app portal. An app or website owner shows ads to
                            users and earns money on clicks, views, or
                            transactions (affiliate programs).
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>04.</h4>
                            <h5>In-app purchase</h5>
                          </div>
                          <p>
                            It lets the users buy special products as the
                            exclusive merchandise from the app; it can be in the
                            form of emojis, icons, glass, gifts, and many more
                            items.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid">
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>05.</h4>
                            <h5>Paid Premium Plans</h5>
                          </div>
                          <p>
                            To unlock certain features in the free version,
                            users have to pay some amount. For example, the user
                            accidentally swiped the profile to the left. Now,
                            only premium plan subscribers can fix the error.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <div className="money_title_nmber">
                            <h4>06.</h4>
                            <h5>Boost</h5>
                          </div>
                          <p>
                            This is a new feature, letting users&apos; profile
                            to be on the top for 30 minutes. When you subscribe
                            to boost, your profile gets a maximum chance for the
                            views and matches.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid tinder_dvlp_app full-width-all-section">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="sm_column_text sm_content_element ">
                  <div className="sm_wrapper">
                    <h3 className="tinder_title text-center">
                      <span style={{ fontWeight: 'bold' }}>How Much </span> Does
                      It Cost To Develop An App Like Tinder?
                    </h3>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid">
                  <div className="leff_img_dvlp_tinder wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix text-center">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/dvlp_tinder.png`}
                            className="single-image img-fluid"
                            alt="dvlp_tinder"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="right_dvlp_tinder wpb_column vc_column_container col-md-6 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <p>
                            We think Tinder has a simple user interface but it
                            involves a complex architecture and a very
                            complicated development process. So, realistically
                            speaking, it won&apos;t be a low budget app since
                            the estimated development time for such an app can
                            be somewhere around 800 to 1000 hours. Also, many
                            factors are responsible for the development of a
                            mobile app like Tinder that directly influences the
                            cost of development such as complexity of its
                            functionality, features to integrate, third-party
                            integrations, platforms (iOS, Android, or both),
                            UI/UX design, etc.
                          </p>
                          <p>
                            To get an instant quote for a Tinder-like app or to
                            know an average/exact cost to build an app like
                            Tinder, please contact our experts.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid tinder_industies tiktok_idustries uber-cmnls z_sctn_18 z_sctnpdng">
            <div className="container-sl">
              <div className="row">
                <div className="wpb_column vc_column_container vc_col-sm-1 sm-border-box" />
                <div className="wpb_column vc_column_container vc_col-sm-10 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="sm_column_text sm_content_element  inln_ttl z_df_p">
                      <div className="sm_wrapper">
                        <h3
                          className="tinder_title white_line_tilt text-center"
                          style={{ textAlign: 'center' }}
                        >
                          <span style={{ fontWeight: 'bold' }}>Which </span>
                          Industries Are Benefiting From Online Apps?
                        </h3>
                        <p
                          style={{ textAlign: 'center', color: '#fff' }}
                          className="mb-5"
                        >
                          Several industrial sectors are witnessing a
                          renaissance in the way they operate after the arrival
                          and growth in demand for online apps. Some of them are
                          listed below.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="wpb_column vc_column_container vc_col-sm-1 sm-border-box" />
              </div>
              <div className="row">
                <div className="bnftng_clmn wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_1 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Healthcare</h5>
                        <p>
                          With the introduction of on-demand services in
                          Healthcare; now it is easier to single-handedly deal
                          and resolve the healthcare issues, without a fail. You
                          can order medicines, book diagnostics tests, book
                          doctors&apos; appointments, and collect reports on the
                          go.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bnftng_clmn wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_2 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Education</h5>
                        <p>
                          The education industry has benefitted hugely from the
                          on-demand services, as it allows the users to take
                          classes and gain knowledge from the comfort of their
                          home. Now, students, educators, and institutions can
                          connect in ways that were never possible in the past.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bnftng_clmn wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_3 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Entertainment</h5>
                        <p>
                          When it comes to booking tickets of movies or events,
                          on-demand apps, come handy. They help the users to get
                          them their required services at just one touch of
                          their mobile phones; helping in increasing brand
                          recognition, business revenue, and user engagement at
                          the same time.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bnftng_clmn clrfx_sm wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_4 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Delivery</h5>
                        <p>
                          With the help of on-demand apps, now businesses can
                          empower users and retailers to buy and sell almost
                          everything through online mode; streamlining&nbsp;the
                          process of generating revenues, sales, and access to
                          wider targets.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bnftng_clmn wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_5 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Professional Services</h5>
                        <p>
                          The professional services have gained the maximum
                          benefits from the on-demand services, as it allows the
                          users to hire professionals for all their household
                          works or any work in general from one place.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bnftng_clmn wpb_column vc_column_container col-md-2 sm-border-box">
                  <div className="wpb_wrapper">
                    <div className="vc_icon_element vc_icon_element-outer bnftng_i_6 vc_icon_element-align-left">
                      <div className="vc_icon_element-inner vc_icon_element-color-blue vc_icon_element-size-md vc_icon_element-style- vc_icon_element-background-color-grey">
                        <span className="vc_icon_element-icon fa fa-adjust" />
                      </div>
                    </div>
                    <div className="sm_column_text sm_content_element ">
                      <div className="sm_wrapper">
                        <h5>Transportation</h5>
                        <p>
                          The transportation sector owns a lot to the on-demand
                          economy, allowing users to book a cab as per their
                          convenience. The online taxi service apps are changing
                          the face of how transportation works to make the lives
                          of citizens better and better.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="vc_row wpb_row vc_row-fluid dating_main_scn">
            <div className="container-sl wpb_column vc_column_container vc_col-sm-12 sm-border-box">
              <div className="wpb_wrapper">
                <div className="sm_column_text sm_content_element ">
                  <div className="sm_wrapper">
                    <h3 className="tinder_title text-center">
                      <span style={{ fontWeight: 'bold' }}>Apps </span>Built By
                      WebClues Infotech
                    </h3>
                  </div>
                </div>
                <div className="row vc_row wpb_row vc_inner vc_row-fluid inner_dating_app">
                  <div className="wpb_column vc_column_container col-md-4 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix left">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/datting_1-1.png`}
                            className="single-image img-fluid"
                            alt="datting_1-1"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h4>Bezzi</h4>
                          <p>
                            Find, Connect, Meet - Bezzi lets you meet single
                            people in your area. This online dating community is
                            made specifically for those ready to enjoy the prime
                            part of life.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-4 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix left">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/datting_2-2.png`}
                            className="single-image img-fluid"
                            alt="datting_2-2"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h4>Vlog Me</h4>
                          <p>
                            It is a video sharing platform dedicated to the
                            growing popularity of Video blogging. Users can
                            enjoy content from their favourite Vloggers, explore
                            new, trending and top rated vlogs and receive the
                            added incentive of building their own Viewer rating.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="wpb_column vc_column_container col-md-4 sm-border-box">
                    <div className="wpb_wrapper">
                      <div className="sm-image sm_content_element clearfix left">
                        <div className="sm-image-wrap">
                          <img
                            src={`${CDN_URL}/assets/images/solutions/tinder_blog_img/datting_3-2.png`}
                            className="single-image img-fluid"
                            alt="datting_3-2"
                          />
                        </div>
                      </div>
                      <div className="sm_column_text sm_content_element ">
                        <div className="sm_wrapper">
                          <h4>Popcircl</h4>
                          <p>
                            This app puts you in the epicenter of social
                            experience, with rich media shared around you. Users
                            can share media and links directly from the
                            internet, unlike Instagram.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="our_client_say">
            <div className="container-sl">
              <div className="title text-center pb-4">
                <h3 className="mlt_ttl lt_bl_bbl text-center d-inline-block mb-4">
                  Listen From Our Clients
                </h3>
                <p style={{ textAlign: 'center', fontWeight: '400' }}>
                  We&apos;ve helped many clients globally to solve complex
                  business problems with our developed mobile app solutions. Our
                  collaboration with clients results in a long-term partnership.
                  Check what they have to say about the services they have
                  received from us.
                </p>
              </div>
              <div className="client_video_scn">
                <Slider {...testimonialsSettings}>
                  {TestimonialsVideoContent?.map((video, index) => (
                    <div key={index + 1}>
                      <div className="inner_client_scn image_block video_team_testimonial">
                        <div className="video_team">
                          <ReactPlayer
                            url={video.videourl}
                            className="react-player cursorPlayArea"
                            controls={false}
                            playing={playingStates[index]}
                            width="100%"
                            height="100%"
                            playIcon={
                              <Button
                                variant="outline-secondary"
                                aria-label="play_btn_client1"
                                className="bg-transp­arent player-action-btn playing--btn"
                              >
                                <img
                                  src="/assets/images/play-button.svg"
                                  className=""
                                  alt=""
                                />
                              </Button>
                            }
                            light={video.videThumb}
                            onClick={() => handleSetPlaying(index)}
                            onPause={pause}
                          />
                          {playingStates[index] ? (
                            <Button
                              className="pauseVbtn player-action-btn"
                              onClick={pause}
                            >
                              <img
                                src="/assets/images/pause-icon.svg"
                                className=""
                                alt=""
                              />
                            </Button>
                          ) : (
                            <Button
                              variant="outline-secondary"
                              aria-label="play_btn_client1"
                              className="pauseVbtn player-action-btn"
                              onClick={() => handleSetPlaying(index)}
                            >
                              <img
                                src="/assets/images/play-button.svg"
                                className=""
                                alt=""
                              />
                            </Button>
                          )}
                        </div>
                        <div className="client_info_cnt">
                          <p>{video.location}</p>
                          <h4>{video.title}</h4>
                          <h6>{video.destination}</h6>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
          <div className="solutions_faq tinder_faq  z_sctn_20 z_sctnpdng bg_black_tiktok">
            <div className="container">
              <div className="row">
                <div className="col-md-12 text-center inln_ttl">
                  <h3 className="tinder_title text-center">
                    <span style={{ fontWeight: 'bold' }}>FAQ&apos;s</span>
                  </h3>
                </div>
                <div className="col-md-12" />
                <Accordion defaultActiveKey="0" flush>
                  {faqJsonData.map((faq) => (
                    <Accordion.Item key={faq.id} eventKey={faq.id}>
                      <Accordion.Header>{faq.title}</Accordion.Header>
                      <Accordion.Body>{faq.description}</Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
    </PageWrapper>
  )
}

export default AppLikeTinder
